import { generateApiClient } from '@guiker/rest-client'

import { AdminApi, AuthenticatedApi, PublicApi } from '../api-definition'
import { config } from '../config'

export const AdminApiClient = generateApiClient(config.apiName, AdminApi.routes)
export const AuthenticatedApiClient = generateApiClient(config.apiName, AuthenticatedApi.routes)
export const PublicApiClient = generateApiClient(config.apiName, PublicApi.routes)
